import React, { useState, useRef, useEffect } from 'react';
import { mappingIcon } from '../mapping.es.js';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const InnerIcon = (props, ref) => {
  const _a = props, { name, style } = _a, rest = __objRest(_a, ["name", "style"]);
  const url = mappingIcon[name];
  const [lazyUrl, setLazyUrl] = useState();
  const fallbackRef = useRef(null);
  const iconRef = ref || fallbackRef;
  const entry = useIntersectionObserver(iconRef, {});
  const isVisible = !!(entry == null ? void 0 : entry.isIntersecting);
  useEffect(() => {
    if (!url || !isVisible || lazyUrl === url)
      return;
    setLazyUrl(url);
  }, [url, isVisible, lazyUrl]);
  if (!url) {
    if (!name)
      return null;
    return /* @__PURE__ */ React.createElement("span", {
      style: { fontSize: (style == null ? void 0 : style.fontSize) || "1em" }
    }, "\u2757");
  }
  const isColorIcon = ["Colored", "TwoTone"].some((el) => name.endsWith(el));
  const getStyleNormalIcon = () => {
    const basicStyle = __spreadProps(__spreadValues({}, style), {
      display: "inline-block",
      width: (style == null ? void 0 : style.fontSize) || "1em",
      height: (style == null ? void 0 : style.fontSize) || "1em",
      WebkitMaskSize: "contain",
      WebkitMaskRepeat: "no-repeat",
      WebkitMaskPosition: "center",
      verticalAlign: "middle"
    });
    if (lazyUrl) {
      basicStyle.WebkitMaskImage = `url("${lazyUrl}")`;
      basicStyle.background = (style == null ? void 0 : style.color) || "currentColor";
    }
    return basicStyle;
  };
  const getStyleColorIcon = () => {
    style == null ? true : delete style.backgroundColor;
    const styleColor = __spreadProps(__spreadValues({}, style), {
      display: "inline-block",
      width: (style == null ? void 0 : style.fontSize) || "1em",
      height: (style == null ? void 0 : style.fontSize) || "1em",
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      verticalAlign: "middle"
    });
    if (lazyUrl)
      styleColor.backgroundImage = `url("${lazyUrl}")`;
    return styleColor;
  };
  return /* @__PURE__ */ React.createElement("span", __spreadValues({
    ref: iconRef,
    style: isColorIcon ? getStyleColorIcon() : getStyleNormalIcon()
  }, rest));
};
const Icon = React.forwardRef(InnerIcon);

export { Icon };
